import Axios from 'axios'
import router from '../router'
// import ElementUI from 'element-ui'
import md5 from 'js-md5'

Axios.defaults.timeout = 300000;// 响应时间
// Axios.defaults.baseURL = process.env.HOST;
Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

Axios.interceptors.request.use(config => {
    console.log('http:', config.url.match(/^(wechat\/)/))
    if (config.url.match(/^(wechat\/)/)) {
        config.baseURL = process.env.HOST
    } else if (config.url.match(/^(wx_pay\/)/)) {
        config.baseURL = process.env.HOST_PAY
    } else {
        config.baseURL = process.env.HOST_JAVA
    }
    // console.log(str.match(reg))
    let Appkey = '1874100931';
    let AppSecret = 'ecaa5b968a76fbf15bc67fc50335fc61';

    let timeTamp = parseInt(new Date().getTime() / 1000);
    let LcSign = md5(Appkey + timeTamp + AppSecret);
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    config.headers['LC-Appkey'] = Appkey;
    config.headers['LC-Sign'] = LcSign;
    config.headers['LC-Timestamp'] = timeTamp;
    // config.headers['LC-Session'] = '0b951e779eb246b926b0f50fb64e7144120000';
    if (userInfo && userInfo.session_id) {
        config.headers['LC-Session'] = userInfo.session_id;
    } else {
        config.headers['LC-Session'] = '0b951e779eb246b926b0f50fb64e71440';
    }
    return config;
}, error => {
    return Promise.reject(error);
});

Axios.interceptors.response.use(response => {
    return response;
}, error => {
    return Promise.reject(error);
});

/**
 * 公共请求入口
 * @param param 'object'
 * @param url   'string'
 * @param type  'get || post'
 * @returns {Promise}
 */
export const commonPromise = (param = {}, url, type) => {
    console.log(url)
    console.log('请求参数', param)
    console.log(param instanceof Object)
    return new Promise((resolve, reject) => {
        let request = type === 'post' ? Axios({url: param instanceof Object ? url : url + '/' + param, method: 'post', data: param instanceof Object ? param : {}}) : Axios({url: param instanceof Object ? url : url + '/' + param, method: 'get', params: param instanceof Object ? param : {}})
        request.then(res => {
            // console.log(res)
            if (res.data.code === 0) {
                resolve(res.data);
            } else if (res.data.code === 1) {
                resolve(res.data);
            } else if (res.data.code === 2) {
                resolve(res.data);
            } else if (res.data.code === 3) {
                resolve(res.data);
            } else if (res.data.code === 4) {
                resolve(res.data);
            } else if (res.data.code === 101) {
                resolve(res.data);
            } else if (res.data.code === 8010) {
                resolve(res.data);
            } else if (res.data.code === 8009) {
                resolve(res.data);
            } else if (res.data.code === 8008) {
                resolve(res.data);
            } else if (res.data.code === 8007) {
                resolve(res.data);
            } else if (res.data.code === 1006) {
                resolve(res.data);
            } else if (res.data.code === 1007) {
                resolve(res.data);
            } else if (res.data.code === 1004) {
                localStorage.removeItem('userInfo');
                // ElementUI.Message.error(res.data.msg);
                reject(res.data.msg);
            } else {
                // ElementUI.Message.error(res.data.msg);
                reject(res.data.msg);
            }
        }).catch(err => {
            reject(err.data.msg);
        });
    })
}



// WEBPACK FOOTER //
// ./src/http/index.js